export const buildRoleScopedSavePayload = ({
  cleanedFormData = {},
} = {}) => {
  if (!cleanedFormData || typeof cleanedFormData !== 'object' || Array.isArray(cleanedFormData)) {
    return {};
  }

  const { _suggestions, ...payloadFormData } = cleanedFormData;
  return payloadFormData;
};
